/* eslint-disable no-unused-vars */
export enum Environment {
    Development = 'Development',
    Staging = 'Staging',
    Integration = 'Integration',
    Production = 'Production'
}

export enum OrgUnitType {
    Region = "REG",
    Country = "CTY",
    Company = "CMP",

    BusinessArea = "BSA",
    Division = "DIV",
    ProductGroup = "PGR",
}

export enum ObjectType {
    Application = 'APP',

    PrimaryCostAgreement = 'AGR',
    PrimaryCostAccrual = 'ACR'
}

export class Status {
    public static readonly success: string = 'Success';
    public static readonly warning: string = 'Warning';
    public static readonly fail: string = 'Fail';
}

export class SignalREvents {
    public static readonly jobStatusChanged: string = 'jobStatusChanged';
    public static readonly jobProgressMaxValueChanged: string = 'jobProgressMaxValueChanged';
    public static readonly jobProgressValueChanged: string = 'jobProgressValueChanged';
    public static readonly sendJobTimeline: string = 'sendJobTimeline';
}